import { buildURL } from 'utils/buildUrl'
import ApiService from './ApiService'

const endpoint = '/patients'

export async function apiCreatePatient(data) {
    return ApiService.fetchData({
        url: `${endpoint}`,
        method: 'post',
        data,
    })
}

export async function apiGetPatients(queryParams = {}) {
    // Extract filterData and flatten relevant fields
    const { filterData, ...rest } = queryParams
    const flatParams = { ...rest }

    // Add pendingOnly to query params if set
    if (filterData?.pendingOnly) {
        flatParams.pendingOnly = true
    }

    const queryString = Object.entries(flatParams)
        .filter(([_, value]) => value !== undefined && value !== null && value !== '')
        .map(
            ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('&')
    // Add the query string to the URL if it's not empty
    const url = queryString ? `${endpoint}?${queryString}` : endpoint
    return ApiService.fetchData({
        url: url,
        method: 'get',
    })
}

export async function apiGetPatient(id) {
    const url = buildURL(endpoint, [id], {})
    return ApiService.fetchData({
        url,
        method: 'get',
    })
}

export async function apiGetSurveyData(id) {
    return ApiService.fetchData({
        url: `${endpoint}/survey/${id}`,
        method: 'get',
    })
}

export async function apiEditPatient(data, id) {
    return ApiService.fetchData({
        url: `${endpoint}/${id}`,
        method: 'patch',
        data,
    })
}

export async function apiEditSurvey(data, id) {
    return ApiService.fetchData({
        url: `${endpoint}/survey/${id}`,
        method: 'patch',
        data,
    })
}

export async function apiDeletePatient(data) {
    return ApiService.fetchData({
        url: `${endpoint}/${data}`,
        method: 'delete',
        data,
    })
}

export async function apiGetPatientConsultationsStats({
    id,
    queryParams = {},
}) {
    const url = buildURL(`${endpoint}/consultations-stats`, [id], queryParams)
    return ApiService.fetchData({
        url: url,
        method: 'get',
    })
}

export async function apiGetPatientConsultationsHistory({
    id,
    queryParams = {},
}) {
    const url = buildURL(`${endpoint}/consultations-history`, [id], queryParams)
    return ApiService.fetchData({
        url: url,
        method: 'get',
    })
}

export async function apiGetPatientObservationsHistory(id, queryParams = {}) {
    const url = buildURL(`${endpoint}/observations-history`, [id], queryParams)

    return ApiService.fetchData({
        url: url,
        method: 'get',
    })
}

export async function apiGetOldAppointementsHistory({ id, queryParams = {} }) {
    console.log(queryParams)
    const url = buildURL(`${endpoint}/old-sessions-history`, [id], queryParams)
    console.log(url)
    return ApiService.fetchData({
        url: url,
        method: 'get',
    })
}

export async function apiGetPatientRevenuesStats({ id, queryParams = {} }) {
    const url = buildURL(`${endpoint}/payments-stats`, [id], queryParams)
    return ApiService.fetchData({
        url: url,
        method: 'get',
    })
}

export async function apiGetPendingPatientsCount() {
    return ApiService.fetchData({
        url: `${endpoint}/pending/count`,
        method: 'get',
    })
}

export async function apiConfirmPatient(id) {
    return ApiService.fetchData({
        url: `${endpoint}/${id}/confirm`,
        method: 'patch',
    })
}

export async function apiDeclinePatient(id) {
    return ApiService.fetchData({
        url: `${endpoint}/${id}/decline`,
        method: 'patch',
    })
}
